import React, { useContext, useEffect } from "react";
import { Box, Container, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { GlobalContext } from "../../context/Provider";
import getAplications from "../../context/actions/aplications/getAplications";
import { DocumentacionMainToolbar } from "../../components/documentacion/documentacion-main-toolbar";
import { EndpointLogin } from "../../components/documentacion/endpoints/endpoint-login";
import { EndpointRefresh } from "../../components/documentacion/endpoints/endpoint-refresh";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { EndpointGenerateForm } from "../../components/documentacion/endpoints/endpoint-generate-form";

const Docs = () => {
  const { aplicationsDispatch, aplicationsState } = useContext(GlobalContext);
  const [expandedLogin, setexpandedLogin] = React.useState(false);
  const [expandedRefresh, setExpandedRefresh] = React.useState(false);
  const [expandedForm, setExpandedForm] = React.useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const URL_VIDEO_DEMO = "https://www.farmalink.com.ar/share/s/kZyO73--R96cju9_vgfeFQ";
  const URL_VIDEO_SISA = "https://www.farmalink.com.ar/cs/idcplg?IdcService=GET_FILE&dID=164217&dDocName=WCC_PROD-351292";

  const {
    aplications: { data },
  } = aplicationsState;

  useEffect(() => {
    if (data.length === 0) {
      getAplications()(aplicationsDispatch);
    }
  }, [data]);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 2,
        backgroundColor: "white",
      }}
    >
      <Container maxWidth={false} sx={{ px: { xs: 1, sm: 2, md: 3, lg: 4 } }}>
        <Box sx={{ my: 3 }}>
          <DocumentacionMainToolbar />
          <Grid sx={{ my: 2 }}>
            <Typography
              sx={{
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem", lg: "1.1rem" },
                color: "primary.dark",
                fontWeight: "700",
              }}
            >
              {" "}
              Base URL
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" },
                color: "#067acc",
                my: 1,
                wordBreak: "break-all",
              }}
            >
              {process.env.REACT_APP_API_BASE_URL}
            </Typography>
          </Grid>
          <Grid sx={{ my: 2 }}>
                        <Typography
                          sx={{ fontSize: "1rem", color: "primary.dark", mb: 2 }}
                          variant="h4"
                        >
                          Video informativo - Demo:{" "}
                          <Typography
                            component="a"
                            href={URL_VIDEO_DEMO}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              fontSize: isMobile ? "0.9rem" : "1.00rem",
                              color: "#067acc",
                              textDecoration: "underline",
                              "&:hover": {
                                textDecoration: "none",
                              },
                            }}
                          >
                            {URL_VIDEO_DEMO}
                          </Typography>
                        </Typography>
                        <Typography
                          sx={{ fontSize: "1rem", color: "primary.dark", mb: 2 }}
                          variant="h4"
                        >
                          Video informativo - Verificación SISA:{" "}
                          <Typography
                            component="a"
                            href={URL_VIDEO_SISA}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              fontSize: isMobile ? "0.9rem" : "1.00rem",
                              color: "#067acc",
                              textDecoration: "underline",
                              "&:hover": {
                                textDecoration: "none",
                              },
                            }}
                          >
                            {URL_VIDEO_SISA}
                          </Typography>
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: isMobile ? "0.9rem" : "1.00rem",
                            color: "primary.dark",
                          }}
                        >
                          Los siguientes API endpoint se utilizan para generar un
                          formulario de receta.
                        </Typography>
                      </Grid>

          <Box>
            <Accordion
              expanded={expandedLogin}
              onChange={() => setexpandedLogin(!expandedLogin)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel12-header"
                sx={{
                  background: "#D4F5E6",
                  borderRadius: 1,
                  py: { xs: 0.5, sm: 1, md: 1.5 },
                }}
              >
                <Grid
                  container
                  spacing={1}
                  sx={{
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Grid
                    item
                    xs={3}
                    sm={2}
                    md={1}
                    sx={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Box
                      sx={{
                        background: "#49cc90",
                        borderRadius: 1,
                        px: 1,
                        py: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          color: "white",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.8rem" },
                        }}
                      >
                        POST
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={10}
                    md={11}
                    sx={{ alignItems: "center", justifyContent: "flex-start" }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem", lg: "1.1rem" },
                        color: "primary.dark",
                        fontWeight: "bold",
                      }}
                    >
                      Login
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: { xs: "10px 10px 15px", sm: "10px 15px 20px", md: "10px 20px 25px", lg: "10px 30px 30px" } }}>
                <EndpointLogin />
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedRefresh}
              onChange={() => setExpandedRefresh(!expandedRefresh)}
              sx={{ my: 2 }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel12-header"
                sx={{
                  background: "#D4F5E6",
                  borderRadius: 1,
                  py: { xs: 0.5, sm: 1, md: 1.5 },
                }}
              >
                <Grid
                  container
                  spacing={1}
                  sx={{
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Grid
                    item
                    xs={3}
                    sm={2}
                    md={1}
                    sx={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Box
                      sx={{
                        background: "#49cc90",
                        borderRadius: 1,
                        px: 1,
                        py: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          color: "white",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.8rem" },
                        }}
                      >
                        POST
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={10}
                    md={11}
                    sx={{ alignItems: "center", justifyContent: "flex-start" }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem", lg: "1.1rem" },
                        color: "primary.dark",
                        fontWeight: "bold",
                      }}
                    >
                      Refresh Token
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: { xs: "10px 10px 15px", sm: "10px 15px 20px", md: "10px 20px 25px", lg: "10px 30px 30px" } }}>
                <EndpointRefresh />
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedForm}
              onChange={() => setExpandedForm(!expandedForm)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel12-header"
                sx={{
                  background: "#D4F5E6",
                  borderRadius: 1,
                  py: { xs: 0.5, sm: 1, md: 1.5 },
                }}
              >
                <Grid
                  container
                  spacing={1}
                  sx={{
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Grid
                    item
                    xs={3}
                    sm={2}
                    md={1}
                    sx={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Box
                      sx={{
                        background: "#49cc90",
                        borderRadius: 1,
                        px: 1,
                        py: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          color: "white",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.8rem" },
                        }}
                      >
                        POST
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={10}
                    md={11}
                    sx={{ alignItems: "center", justifyContent: "flex-start" }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem", lg: "1.1rem" },
                        color: "primary.dark",
                        fontWeight: "bold",
                      }}
                    >
                      Generar link de formulario
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: { xs: "10px 10px 15px", sm: "10px 15px 20px", md: "10px 20px 25px", lg: "10px 30px 30px" } }}>
                <EndpointGenerateForm />
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Docs;
